<template>
    <transition name="page" mode="out-in">
        <div class="cover" v-if="loading">
            <div id="ballWrapper">
                <div id="ball">
                    <img src="../../../img/ball.svg" width="100%" height="100%">
                </div>
                <div id="ballShadow"></div>
            </div>
        </div>
    </transition>
</template>

<style lang="stylus" scoped>
    .cover
        position fixed
        height 100%
        width 100%
        top 0
        left 0
        background #fff
        z-index 1999

    /* 3D Bouncing ball */

    #ballWrapper
        width 140px
        height 300px
        position fixed
        left 50%
        top 35%
        margin-left -70px
        z-index 100
        transform scale(1)
        transition all 5s linear 0s
        cursor pointer

    #ballWrapper:active
        transform scale(0)
        cursor pointer

    #ball
        width 140px
        height 140px
        border-radius 70px
        position absolute
        top 0
        z-index 11
        animation jump 1s infinite
        cursor pointer

    #ballShadow
        position absolute
        left 50%
        bottom 0
        z-index 10
        margin-left -30px
        width 60px
        height 75px
        background rgba(20, 20, 20, .1)
        box-shadow 0px 0 20px 35px rgba(20, 20, 20, .1)
        border-radius 30px / 40px
        transform scaleY(.3)
        animation shrink 1s infinite

    /* Animations */

    @keyframes jump
        0%
            top 0
            animation-timing-function ease-in
        50%
            top 140px
            height 140px
            animation-timing-function ease-out
        55%
            top 160px
            height 120px
            border-radius 70px / 60px
            animation-timing-function ease-in
        65%
            top 120px
            height 140px
            border-radius 70px
            animation-timing-function ease-out
        95%
            top 0
            animation-timing-function ease-in
        100%
            top 0
            animation-timing-function ease-in

    @keyframes shrink
        0%
            bottom 0
            margin-left -30px
            width 60px
            height 75px
            background rgba(20, 20, 20, .1)
            box-shadow 0px 0 20px 35px rgba(20, 20, 20, .1)
            border-radius 30px / 40px
            animation-timing-function ease-in
        50%
            bottom 30px
            margin-left -10px
            width 20px
            height 5px
            background rgba(20, 20, 20, .3)
            box-shadow 0px 0 20px 35px rgba(20, 20, 20, .3)
            border-radius 20px / 20px
            animation-timing-function ease-out
        100%
            bottom 0
            margin-left -30px
            width 60px
            height 75px
            background rgba(20, 20, 20, .1)
            box-shadow 0px 0 20px 35px rgba(20, 20, 20, .1)
            border-radius 30px / 40px
            animation-timing-function ease-in
</style>

<script>
    import {mapGetters} from 'vuex'

    export default {
        name: 'spinner',

        computed: {
            ...mapGetters({settings: 'local/settings'}),

            loading() {
                return this.settings('loading')
            }
        }
    }
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/spinner/Spinner.vue